<div class="landing">

  <!-- Hero -->
  <section class="hero">
    <div class="hero-content">
      <h1>You're connected to the<br/><span class="accent">CEADS</span> Data Space</h1>

      <p class="hero-intro">
        CEADS (Common European Agricultural Data Space) enables trusted access, sharing and
        reuse of agricultural data across Europe to support innovation, sustainability and
        food security.
      </p>
      <p class="hero-body">
        This connector gives you secure access to the CEADS ecosystem, where data is shared
        under clear policies and full control remains with data providers.
      </p>

      <div class="hero-actions">
        <a mat-flat-button class="btn-primary" [href]="aboutUrl" target="_blank" rel="noopener">
          <mat-icon>open_in_new</mat-icon> About CEADS
        </a>
        <a mat-stroked-button class="btn-ghost" [href]="documentationUrl" target="_blank" rel="noopener">
          <mat-icon>menu_book</mat-icon> Documentation
        </a>
        <a *ngIf="onboardingUrl" mat-stroked-button class="btn-ghost" [href]="onboardingUrl" target="_blank" rel="noopener">
          <mat-icon>groups</mat-icon> Onboarding
        </a>
      </div>
    </div>

    <div class="hero-art" aria-hidden="true">
      <!-- Stylized agricultural data network — grown from the CEADS mark aesthetic -->
      <svg viewBox="0 0 460 360" xmlns="http://www.w3.org/2000/svg" role="img">
        <g fill="none" stroke="#2e6b45" stroke-width="1.4" opacity="0.85">
          <path d="M230 350 C 230 250, 215 210, 180 180"/>
          <path d="M230 350 C 230 250, 245 210, 285 175"/>
          <path d="M230 300 C 230 240, 250 220, 300 210"/>
          <path d="M230 300 C 230 250, 205 225, 150 220"/>
          <path d="M230 250 C 230 200, 250 180, 330 140"/>
          <path d="M230 250 C 230 210, 210 185, 130 150"/>
          <path d="M230 210 L 230 90"/>
        </g>

        <!-- leaves -->
        <g fill="#3a9b4e" opacity="0.9">
          <path d="M198 214 c -26 -6 -46 4 -52 22 c 22 4 42 -4 52 -22 z"/>
          <path d="M262 214 c 26 -6 46 4 52 22 c -22 4 -42 -4 -52 -22 z"/>
          <path d="M214 168 c -22 -10 -42 -4 -50 12 c 20 8 40 4 50 -12 z"/>
        </g>

        <!-- connective network lines -->
        <g fill="none" stroke="#4f97f0" stroke-width="1.2" opacity="0.5">
          <line x1="130" y1="150" x2="80" y2="110"/>
          <line x1="330" y1="140" x2="390" y2="120"/>
          <line x1="300" y1="210" x2="360" y2="245"/>
          <line x1="150" y1="220" x2="90" y2="250"/>
          <line x1="230" y1="90" x2="285" y2="55"/>
          <line x1="230" y1="90" x2="175" y2="55"/>
        </g>

        <!-- nodes -->
        <g>
          <circle cx="230" cy="90"  r="14" fill="#35a04a"/>
          <circle cx="285" cy="55"  r="10" fill="#2f7fbf"/>
          <circle cx="175" cy="55"  r="8"  fill="#7bc043"/>
          <circle cx="330" cy="140" r="12" fill="#2f7fbf"/>
          <circle cx="390" cy="120" r="7"  fill="none" stroke="#3a9b4e" stroke-width="2"/>
          <circle cx="130" cy="150" r="11" fill="#3a9b4e"/>
          <circle cx="80"  cy="110" r="7"  fill="none" stroke="#4f97f0" stroke-width="2"/>
          <circle cx="300" cy="210" r="10" fill="#35a04a"/>
          <circle cx="360" cy="245" r="8"  fill="#2f7fbf"/>
          <circle cx="150" cy="220" r="10" fill="#2f7fbf"/>
          <circle cx="90"  cy="250" r="6"  fill="none" stroke="#7bc043" stroke-width="2"/>
        </g>
      </svg>
    </div>
  </section>

  <!-- Two columns -->
  <div class="columns">

    <section class="panel">
      <h2>What you can do with this connector</h2>
      <a class="capability" *ngFor="let cap of capabilities" [routerLink]="[cap.link]">
        <mat-icon>{{cap.icon}}</mat-icon>
        <span>{{cap.label}}</span>
        <mat-icon class="chevron">chevron_right</mat-icon>
      </a>
    </section>

    <section class="panel">
      <h2>CEADS supports key priorities</h2>
      <div class="priorities">
        <div class="priority" *ngFor="let p of priorities">
          <div class="priority-icon" [ngClass]="'tone-' + p.tone">
            <mat-icon>{{p.icon}}</mat-icon>
          </div>
          <div class="priority-title" [ngClass]="'tone-' + p.tone">{{p.title}}</div>
          <div class="priority-desc">{{p.description}}</div>
        </div>
      </div>
    </section>
  </div>

  <!-- Learn more band -->
  <section class="learn-more">
    <div class="learn-icon"><mat-icon>public</mat-icon></div>
    <div class="learn-text">
      <div class="learn-title">Learn more about CEADS</div>
      <div class="learn-body">Visit the CEADS website for news, resources and ways to get involved.</div>
    </div>
    <a mat-stroked-button class="btn-ghost" [href]="websiteUrl" target="_blank" rel="noopener">
      <mat-icon>open_in_new</mat-icon> Visit ceads.eu
    </a>
  </section>

  <!-- Footer -->
  <footer class="landing-footer">
    <img class="footer-mark" src="assets/brand/ceads-logo.png" alt=""/>
    <div class="footer-text">
      <div class="footer-title">CEADS — Common European Agricultural Data Space</div>
      <div class="footer-body">
        Building a trusted, interoperable and secure data space for agriculture and rural
        communities across Europe.
      </div>
    </div>
    <a class="footer-link" [href]="websiteUrl" target="_blank" rel="noopener">
      <mat-icon>public</mat-icon> ceads.eu
    </a>
  </footer>
</div>
